import util from '@utils/util';
import error from '../common/error';
import logreg from '../js/logreg';
import notice from '../common/notice';
import title from '../common/title';
import desc from '../common/desc';
import passwordInput from '../common/password';
import verificateInput from '../common/verificate';
import button from '../common/button';
import codeInput from '../common/code';
import toast from '../common/toast';
export default {
  name: 'regwrap',
  props: {
    name: {
      type: String,
      default: ''
    },
    itc: {
      type: String,
      default: ''
    },
    country: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      code: '',
      password: '',
      codeError: '',
      passwordError: '',
      phoneCode: '',
      cover: false,
      imgCode: '',
      imgCodeError: '',
      toastState: false,
      txt: ''
    };
  },
  computed: {
    actBtn: function actBtn() {
      return !!this.code && !this.codeError && !!this.password && !this.passwordError && !!this.imgCode && !this.imgCodeError;
    }
  },
  components: {
    'error-tip': error,
    'desc-txt': desc,
    'title-txt': title,
    'notice-txt': notice,
    'password-input': passwordInput,
    'verificate-input': verificateInput,
    'code-input': codeInput,
    'button-wrap': button,
    'toast-pop': toast
  },
  methods: {
    changeImgCodeHandle: function changeImgCodeHandle(code) {
      this.imgCode = code;
    },
    changeImgCodeErrorHandle: function changeImgCodeErrorHandle(txt) {
      this.imgCodeError = txt;
    },
    changeCodeErrorHandle: function changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle: function changeCodeHandle(code) {
      this.code = code;
    },
    changePasswordHandle: function changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle: function changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    changeImgCodeValueHandle: function changeImgCodeValueHandle() {
      this.$refs.imgcodeinput.getVerify();
    },
    send: function send() {
      var _this = this;
      try {
        if (this.code && this.password && !this.passwordError && !this.codeError && !this.cover) {
          // name, password, captcha = '', verifyCode = '', verifyCodeType = ''
          this.cover = true;
          var loading = util.loadingFunc();
          logreg.register(this.name, this.password, '', this.code, '4', logreg.REGTYPE.phone, 1, function (state, data) {
            _this.cover = false;
            loading.hide();
            if (state === 'tongdun_fail') {
              _this.showPop('Network error,refresh retry');
              return;
            }
            if (state === 'success') {
              _this.$emit('success', data);
            } else if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(data.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && "".concat(data.data.status)) >= 0) {
              // this.codeError = this.$t(this.$loginLangPrefix('userSign.fkError'));
            } else if (data.errorMessageTMXTip) {
              //
            } else {
              _this.codeError = _this.$t(_this.$loginLangPrefix('userSign.codeError'));
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    gotoLogin: function gotoLogin() {
      this.$emit('inputPhone', 'input', '', '');
    },
    showPop: function showPop(txt) {
      var _this2 = this;
      this.txt = txt;
      this.toastState = true;
      setTimeout(function () {
        _this2.txt = '';
        _this2.toastState = false;
      }, 1500);
    }
  },
  watch: {
    name: function name(val) {
      if (val) {
        var reg = new RegExp(this.itc, 'i');
        this.phoneCode = val.replace(reg, '');
      }
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};